const bxfCopy = {
    svg: '<svg style="flex-shrink: 0;forced-color-adjust: auto;fill: currentcolor; width:1.00rem; height:1.06rem;" viewBox="0 0 16 17"><path d="M7.5.5h3.878a1.5 1.5 0 0 1 1.06.44l2.121 2.123A1.5 1.5 0 0 1 15 4.122V11a1.5 1.5 0 0 1-1.5 1.5h-6A1.5 1.5 0 0 1 6 11V2A1.5 1.5 0 0 1 7.5.5m-5 4H5v2H3v8h6v-1h2V15a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 1 15V6a1.5 1.5 0 0 1 1.5-1.5"/></svg>',
};

export { bxfCopy as default };
